export default "__VITE_PUBLIC_ASSET__5422d769__"